import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import styles from "./collapsible-card.module.css";
import { Root, Content, Trigger, Header, Item } from "@radix-ui/react-accordion";
import { CardHeading } from '../card-heading/card-heading';
import { CardContent } from '../card-content/card-content';
import { AirFilterIcon } from "../icons/air-filter-icon";
import { OilFilterIcon } from "../icons/oil-filter-icon";
import { CabinFilterIcon } from "../icons/cabin-filter-icon";
import { FuelFilterIcon } from "../icons/fuel-filter-icon";
import { TransmissionFilterIcon } from "../icons/transmission-filter-icon";
import { FrontBrakePadsIcon } from "../icons/front-brake-pads-icon";
import { RearBrakePadsIcon } from "../icons/rear-brake-pads-icon";

export const CollapsibleCard = ({ product }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const searchParams = new URLSearchParams(location.search);
    const initialValue = searchParams.get("accordion") || null;

    const [openValue, setOpenValue] = useState(initialValue);

    const handleValueChange = (value) => {
        setOpenValue(value);

        // Обновляем query param, не трогая другие параметры
        const params = new URLSearchParams(location.search);
        if (value) {
            params.set("accordion", value);
        } else {
            params.delete("accordion");
        }

        // Используем replace, чтобы не засорять историю
        navigate(`${location.pathname}?${params.toString()}`, { replace: true, preventScrollReset: true });
    };



    return (
        <Root
            className={styles.Root}
            type="single"
            collapsible
            value={openValue}
            onValueChange={handleValueChange}
            defaultValue={initialValue || undefined}
        >
            {product?.map(item => (
                <Item key={item?.id} className={styles.Item} value={item?.id.toString()}>
                    <CardHeading product={item} trigger={
                        <Header className={styles.Header}>
                            <Trigger className={styles.Trigger}></Trigger>
                        </Header>
                    } />
                    <Content className={styles.Content}>
                        <div className={styles.contnentContainer}>
                            <CardContent category_name={"Фильтр\nвоздушный"} category_img={<AirFilterIcon />} products={item?.airfilters} />
                            <CardContent category_name={"Фильтр\nмасляный"} category_img={<OilFilterIcon />} products={item?.oil_filters} />
                            <CardContent category_name={"Фильтр\nсалона"} category_img={<CabinFilterIcon />} products={item?.cabin_filters} />
                            <CardContent category_name={"Фильтр\nтопливный"} category_img={<FuelFilterIcon />} products={item?.fuel_filters} />
                            <CardContent category_name={"Фильтр авто.\nтрансмиссии"} category_img={<TransmissionFilterIcon />} products={item?.transmission_filters} />
                            <CardContent category_name={"Передние\nколодки"} category_img={<FrontBrakePadsIcon />} products={item?.front_brake_pads} />
                            <CardContent category_name={"Задние\nколодки"} category_img={<RearBrakePadsIcon />} products={item?.rear_brake_pads} />
                        </div>
                    </Content>
                    <div className={styles.trigger_holder}>
                        <Header className={styles.Header}>
                            <Trigger className={styles.Trigger}></Trigger>
                        </Header>
                    </div>
                </Item>
            ))}
        </Root>
    );
};
